export { ScrollView, type ScrollViewProps } from './scroll-view';
